import { DictionaryAttribute } from 'lib';
import { REFERENCE_TYPE } from '../dicitionary.helper';
import {
    DATA_TYPE_GROUPS,
    getDTGroup,
} from '../dictionary-manager/dictionary-manager-helper';

export class AttributeCrosswalk {
    crosswalk = new Map();

    constructor(arr: DictionaryAttribute[]) {
        this.initCrosswalk(arr);
    }

    getItem(id: string): any {
        return this.crosswalk.get(id);
    }

    possiblySetAttributeDataType(attrib: any, value: any): any {
        // If we are changing any Object or Object[] attribute to something else, remove any potential children.
        if (
            getDTGroup(attrib.datatype) === DATA_TYPE_GROUPS.OBJECT &&
            getDTGroup(value.datatype) !== DATA_TYPE_GROUPS.OBJECT
        ) {
            delete attrib.nodeAttributes;
        }
        attrib.datatype = value.datatype;

        return attrib;
    }

    possiblySetNodeAttributes(attrib: any, value: any): any {
        if (value?.nodeAttributes) {
            attrib.nodeAttributes = value?.nodeAttributes;
        } else {
            delete attrib.nodeAttributes;
        }

        return attrib;
    }

    possiblySetEnumValues(attrib: any, value: any): any {
        if (getDTGroup(value.datatype) === DATA_TYPE_GROUPS.ENUM) {
            attrib.enumValues = value?.enumValues;
        } else {
            delete attrib.enumValues;
        }

        return attrib;
    }

    possiblySetPrecisionValue(attrib: any, value: any): any {
        if (getDTGroup(value.datatype) === DATA_TYPE_GROUPS.DECIMAL) {
            attrib.precision = value?.precision;
        } else {
            delete attrib.precision;
        }
    }

    possiblySetNumericValues(attrib: any, value: any): any {
        if (
            getDTGroup(value.datatype) === DATA_TYPE_GROUPS.NUMBER ||
            getDTGroup(value.datatype) === DATA_TYPE_GROUPS.DECIMAL
        ) {
            attrib.min = value?.min;
            attrib.max = value?.max;
        } else {
            delete attrib.min;
            delete attrib.max;
        }
        return attrib;
    }

    possiblySetFingerprintAttributes(attrib: any, value: any): any {
        if (
            getDTGroup(value.datatype) === DATA_TYPE_GROUPS.FINGERPRINT ||
            getDTGroup(value.datatype) === DATA_TYPE_GROUPS.VECTOR
        ) {
            attrib.fingerprintAttributes = value?.fingerprintAttributes;
        } else {
            delete attrib.fingerprintAttributes;
        }

        return attrib;
    }

    possiblySetRegexValue(attrib: any, value: any): any {
        if (getDTGroup(value.datatype) === DATA_TYPE_GROUPS.STRING) {
            attrib.regex = value?.regex;
        } else {
            delete attrib.regex;
        }

        return attrib;
    }

    possiblySetReferenceValue(attrib: any, value: any): any {
        if (
            getDTGroup(value.datatype)?.toLowerCase().includes(REFERENCE_TYPE)
        ) {
            attrib.referenceDictionaryName = value?.referenceDictionaryName;
        } else {
            delete attrib.referenceDictionaryName;
        }

        return attrib;
    }

    setItem(id: string, value: any): void {
        let attrib = this.crosswalk.get(id);

        if (attrib) {
            attrib.displayName = value.displayName;
            attrib.name = value.name;
            attrib.description = value.description;
            attrib.defaultValue = value.defaultValue;
            attrib.required = value.required;
            attrib.precision = value?.precision;
            this.possiblySetNodeAttributes(attrib, value);
            this.possiblySetAttributeDataType(attrib, value);
            this.possiblySetEnumValues(attrib, value);
            this.possiblySetNumericValues(attrib, value);
            this.possiblySetPrecisionValue(attrib, value);
            this.possiblySetFingerprintAttributes(attrib, value);
            this.possiblySetRegexValue(attrib, value);
            this.possiblySetReferenceValue(attrib, value);
        }
    }

    // For now this has to be any to deal with  attributes vs nodeAttributes
    initCrosswalk = (arr: any[]): void => {
        for (const item of arr) {
            if (!item) return;
            const id = crypto.randomUUID();
            item.id = id;
            this.crosswalk.set(id, item);
            if (item.attributes) {
                this.initCrosswalk(item.attributes);
            }
            if (item.nodeAttributes) {
                this.initCrosswalk(item.nodeAttributes);
            }
        }
    };
}
